import '../scss/style.scss'

import { accordion } from './modules/accordion'
import { tabs } from './modules/tabs'
import { overlayMenu } from './modules/overlay-menu'
import { animate } from './modules/animate'
import { videoAutoplay } from './modules/video-autoplay'
import { preload } from './modules/preload'
import { pdfLinks } from './modules/pdf-links'
import { dropdown } from './modules/dropdown'
import { header } from './modules/header'
import { counter } from './modules/counter'
import { dialog } from './modules/dialog'
import { popup } from "./modules/popup";
import { rotatingText } from './modules/rotating-text'

overlayMenu()

dropdown()

pdfLinks()

preload()

animate()

videoAutoplay()

accordion()

tabs()

header()

counter()

dialog()

rotatingText()

popup()

